(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4759],{

/***/ 33818:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/shop/search",
      function () {
        return __webpack_require__(78090);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 78090:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ search; }
});

// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(61261);
// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/index.js
var react = __webpack_require__(91987);
// EXTERNAL MODULE: ./src/components/AppLayout/index.tsx + 40 modules
var AppLayout = __webpack_require__(42413);
// EXTERNAL MODULE: ../../.yarn/unplugged/styled-components-virtual-24edae5a63/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(10278);
// EXTERNAL MODULE: ./src/styles/index.ts
var styles = __webpack_require__(52655);
// EXTERNAL MODULE: ./src/services/tracking.ts
var tracking = __webpack_require__(19676);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@design-system-pc-virtual-0bfff5899a/0/cache/@design-system-pc-npm-4.5.5-5209ca23ee-508cb735dc.zip/node_modules/@design-system/pc/dist/design-system-pc.js
var design_system_pc = __webpack_require__(56341);
;// CONCATENATED MODULE: ./src/feat-components/ShopSearch/CategoryChips.tsx
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  width: 100%;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  cursor: pointer;\n  margin-right: 6px;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}






//* 사용법 *//
// 개별 사용시 props에 text를 입력
// 여러가지의 리스트를 보낼시 list에 string 배열을 보내주면됨
var CategoryChips = function(props) {
    var ref;
    var ref1 = (0,react.useRef)(null);
    (0,react.useEffect)(function() {
        var ref;
        ref1.current && ((ref = ref1.current) === null || ref === void 0 ? void 0 : ref.open(5));
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: props.type === "multi" ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(ChipBox, _objectSpreadProps(_objectSpread({
            props: props
        }, tracking/* default.tagGTM */.Z.tagGTM("shop_search")), {
            children: [
                props.hasRefresh && /*#__PURE__*/ (0,jsx_runtime.jsx)(RefreshIconBox, _objectSpreadProps(_objectSpread({
                    onClick: props.handleReset && props.handleReset
                }, tracking/* default.tagGTM */.Z.tagGTM("shop_search_shop_type_reset_button")), {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* Icongraphy */.Jb, {
                        variant: "ic_refresh",
                        size: 20
                    })
                })),
                props.list ? (ref = props.list) === null || ref === void 0 ? void 0 : ref.map(function(item) {
                    var ref;
                    var isCurrent = Array.isArray(props.currentValue) ? props === null || props === void 0 ? void 0 : (ref = props.currentValue) === null || ref === void 0 ? void 0 : ref.includes(item) : item.code === (props === null || props === void 0 ? void 0 : props.currentValue).code;
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* FilterChip */.GH, _objectSpreadProps(_objectSpread({
                        isAlarm: false,
                        icon: props.useCheckIcon ? {
                            variant: "ic_check_bold",
                            align: "left"
                        } : undefined,
                        isChecked: isCurrent,
                        onClick: function() {
                            return props.onChange && props.onChange(item);
                        }
                    }, tracking/* default.tagGTM */.Z.tagGTM("shop_search_shop_type_multi_button", {
                        "option-value": item.code
                    })), {
                        children: item.name || item.text
                    }), item.code);
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* FilterChip */.GH, _objectSpreadProps(_objectSpread({
                    isChecked: (props === null || props === void 0 ? void 0 : props.currentValue) === props.children,
                    onClick: function() {
                        return props.onClick && props.onClick(props.children);
                    }
                }, (tracking/* default.tagGTM */.Z.tagGTM("shop_search_shop_type_single_button"), {
                    "option-value": props === null || props === void 0 ? void 0 : props.currentValue
                })), {
                    children: props.children
                }))
            ]
        })) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(design_system_pc/* FilterChip */.GH, _objectSpreadProps(_objectSpread({
            isChecked: (props === null || props === void 0 ? void 0 : props.currentValue) === props.children,
            disabled: props.disabled || false,
            onClick: function() {
                return props.onClick && props.onClick(props.children);
            }
        }, (tracking/* default.tagGTM */.Z.tagGTM("shop_search_shop_type_single_button"), {
            "option-value": props === null || props === void 0 ? void 0 : props.currentValue
        })), {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* Icongraphy */.Jb, {
                    variant: "ic_check",
                    fillColor: props.disabled ? styles/* theme.colors.neutral_colors.gray.100 */.rS.colors.neutral_colors.gray[100] : (props === null || props === void 0 ? void 0 : props.currentValue) ? styles/* theme.colors.accent_colors.primary.default */.rS.colors.accent_colors.primary["default"] : styles/* theme.colors.neutral_colors.gray.500 */.rS.colors.neutral_colors.gray[500]
                }),
                props.children
            ]
        }))
    });
};
/* harmony default export */ var ShopSearch_CategoryChips = (CategoryChips);
var ChipBox = (0,styled_components_browser_esm/* default */.ZP)(design_system_pc/* Box */.xu).withConfig({
    displayName: "CategoryChips__ChipBox",
    componentId: "sc-24f11851-0"
})(_templateObject(), function(param) {
    var props = param.props;
    return props.gap || "8px 12px";
});
var RefreshIconBox = (0,styled_components_browser_esm/* default */.ZP)(design_system_pc/* Box */.xu).withConfig({
    displayName: "CategoryChips__RefreshIconBox",
    componentId: "sc-24f11851-1"
})(_templateObject1());

// EXTERNAL MODULE: ./src/ui/BoardPagination/index.ts + 6 modules
var BoardPagination = __webpack_require__(35262);
// EXTERNAL MODULE: ../../.yarn/__virtual__/next-virtual-769137b2ab/0/cache/next-npm-12.2.3-07d597c2b7-b13b42fbb3.zip/node_modules/next/link.js
var next_link = __webpack_require__(49344);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./src/ui/Image/index.ts
var Image = __webpack_require__(71267);
;// CONCATENATED MODULE: ./src/feat-components/ShopSearch/Maps/kakaoMap/Card.tsx
function Card_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function Card_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            Card_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function Card_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function Card_objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        Card_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function Card_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function Card_templateObject() {
    var data = Card_taggedTemplateLiteral([
        "\n  width: 100%;\n  display: flex;\n  gap: 16px;\n  padding: 24px 28px;\n  cursor: pointer;\n"
    ]);
    Card_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Card_templateObject1() {
    var data = Card_taggedTemplateLiteral([
        "\n  min-width: 16px;\n  min-height: 16px;\n"
    ]);
    Card_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = Card_taggedTemplateLiteral([
        "\n  display: flex;\n  flex: 1;\n  gap: 4px;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}







var Card = function(_param) {
    var item = _param.item, hoverItem = _param.hoverItem, setHoverItem = _param.setHoverItem, type = _param.type, isFirstItem = _param.isFirstItem, props = _objectWithoutProperties(_param, [
        "item",
        "hoverItem",
        "setHoverItem",
        "type",
        "isFirstItem"
    ]);
    var ref;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
        href: "/shop/".concat(item.id),
        passHref: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(design_system_pc/* Box */.xu, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* Box */.xu, {
                    width: "390px",
                    ml: 32,
                    mt: isFirstItem ? 11 : 0,
                    borderBottom: "1px solid",
                    borderColor: "color_chip.gray.100"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(CardContainer, Card_objectSpreadProps(Card_objectSpread({
                    backgroundColor: item.id === hoverItem ? "color_chip.gray.50" : "transparent",
                    onMouseOver: function() {
                        return setHoverItem(item.id);
                    },
                    onMouseLeave: function() {
                        return setHoverItem(null);
                    }
                }, props), {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                            src: "http:".concat(item.image.url),
                            alt: "storeImage",
                            width: "72px",
                            height: "72px",
                            objectFit: "cover"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(design_system_pc/* VStack */.gC, {
                            space: 4,
                            alignment: "start",
                            width: "calc(100% - 72px)",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(design_system_pc/* Text */.xv, {
                                    variant: "headline5",
                                    color: item.id === hoverItem ? "color_chip.blue.500" : "color_chip.primary",
                                    children: [
                                        item.type.name,
                                        " ",
                                        item.name
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(StoreInfo, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(IconBox, {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* Icongraphy */.Jb, {
                                                style: {
                                                    position: "relative",
                                                    top: "2px",
                                                    left: "2px"
                                                },
                                                variant: "ic_location",
                                                size: 14,
                                                resize: true,
                                                fillColor: styles/* theme.colors.neutral_colors.gray.700 */.rS.colors.neutral_colors.gray[700]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(design_system_pc/* Text */.xv, {
                                            variant: "body2",
                                            color: "color_chip.gray.600",
                                            children: [
                                                item.address.basic,
                                                item.address.detail
                                            ]
                                        })
                                    ]
                                }),
                                item.telNumber.telYn === "Y" && /*#__PURE__*/ (0,jsx_runtime.jsxs)(StoreInfo, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(IconBox, {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* Icongraphy */.Jb, {
                                                style: {
                                                    position: "relative",
                                                    top: "2px",
                                                    left: "2px"
                                                },
                                                variant: "ic_call",
                                                size: 14,
                                                resize: true,
                                                fillColor: styles/* theme.colors.neutral_colors.gray.700 */.rS.colors.neutral_colors.gray[700]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* Text */.xv, {
                                            variant: "body2",
                                            color: "color_chip.gray.600",
                                            children: item.telNumber.number
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(StoreInfo, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(IconBox, {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* Icongraphy */.Jb, {
                                                style: {
                                                    position: "relative",
                                                    top: "2px",
                                                    left: "2px"
                                                },
                                                variant: "ic_subject",
                                                size: 14,
                                                resize: true,
                                                fillColor: styles/* theme.colors.neutral_colors.gray.700 */.rS.colors.neutral_colors.gray[700]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* Text */.xv, {
                                            variant: "body2",
                                            color: "color_chip.gray.600",
                                            children: item.includeItems.map(function(value, index) {
                                                return index !== 0 ? ", ".concat(value.name) : value.name;
                                            })
                                        })
                                    ]
                                }),
                                item.badges && type === "remodeling" && /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* HStack */.zn, {
                                    space: 4,
                                    children: (ref = item.badges) === null || ref === void 0 ? void 0 : ref.map(function(value, index) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* NewFlag */.zI, {
                                            variant: "solid",
                                            color: "color_chip.blue.50",
                                            textColor: "color_chip.blue.500",
                                            content: value.text
                                        }, "".concat(item.id, "-").concat(index));
                                    })
                                })
                            ]
                        })
                    ]
                }))
            ]
        })
    });
};
/* harmony default export */ var kakaoMap_Card = (Card);
var CardContainer = (0,styled_components_browser_esm/* default */.ZP)(design_system_pc/* Box */.xu).withConfig({
    displayName: "Card__CardContainer",
    componentId: "sc-ff927f87-0"
})(Card_templateObject());
var IconBox = (0,styled_components_browser_esm/* default */.ZP)(design_system_pc/* Box */.xu).withConfig({
    displayName: "Card__IconBox",
    componentId: "sc-ff927f87-1"
})(Card_templateObject1());
var StoreInfo = (0,styled_components_browser_esm/* default */.ZP)(design_system_pc/* Box */.xu).withConfig({
    displayName: "Card__StoreInfo",
    componentId: "sc-ff927f87-2"
})(_templateObject2());

// EXTERNAL MODULE: ../../.yarn/__virtual__/react-kakao-maps-sdk-virtual-57dab0af8b/0/cache/react-kakao-maps-sdk-npm-1.1.5-7d3ebd301d-582e0b66b1.zip/node_modules/react-kakao-maps-sdk/lib/index.modern.js
var index_modern = __webpack_require__(23851);
;// CONCATENATED MODULE: ./src/feat-components/ShopSearch/Maps/kakaoMap/BtnMapRefresh.tsx
function BtnMapRefresh_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function BtnMapRefresh_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            BtnMapRefresh_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function BtnMapRefresh_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function BtnMapRefresh_objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        BtnMapRefresh_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function BtnMapRefresh_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = BtnMapRefresh_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function BtnMapRefresh_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function BtnMapRefresh_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function BtnMapRefresh_templateObject() {
    var data = BtnMapRefresh_taggedTemplateLiteral([
        "\n  width: 182px;\n  height: 48px;\n  border-radius: 24px;\n  gap: 4px;\n  padding: 12px 24px;\n  display: flex;\n\n  align-items: center;\n  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.15);\n  background-color: ",
        ";\n  position: absolute;\n  bottom: 40px;\n  z-index: 9999;\n  left: 50%;\n  cursor: pointer;\n  transform: translateX(-50%);\n"
    ]);
    BtnMapRefresh_templateObject = function _templateObject() {
        return data;
    };
    return data;
}





var BtnMapRefresh = function(_param) {
    var onClick = _param.onClick, props = BtnMapRefresh_objectWithoutProperties(_param, [
        "onClick"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container, BtnMapRefresh_objectSpreadProps(BtnMapRefresh_objectSpread({
        onClick: onClick
    }, props), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* Icongraphy */.Jb, {
                variant: "ic_refresh",
                size: 24,
                resize: true
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* Text */.xv, {
                color: styles/* theme.colors.accent_colors.primary.default */.rS.colors.accent_colors.primary["default"],
                variant: "label_lg_b",
                children: "현 지도에서 검색"
            })
        ]
    }));
};
/* harmony default export */ var kakaoMap_BtnMapRefresh = (BtnMapRefresh);
var Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "BtnMapRefresh__Container",
    componentId: "sc-2bd2f49f-0"
})(BtnMapRefresh_templateObject(), function(param) {
    var theme = param.theme;
    return theme.colors.natural_color.white;
});

// EXTERNAL MODULE: ./src/constants/index.ts + 7 modules
var constants = __webpack_require__(14054);
;// CONCATENATED MODULE: ./src/feat-components/ShopSearch/Maps/kakaoMap/MapButtons.tsx
function MapButtons_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function MapButtons_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            MapButtons_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function MapButtons_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function MapButtons_objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        MapButtons_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function MapButtons_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function MapButtons_templateObject() {
    var data = MapButtons_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  position: absolute;\n  bottom: 40px;\n  right: 24px;\n  z-index: 9999;\n  gap: 16px;\n  justify-content: center;\n"
    ]);
    MapButtons_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function MapButtons_templateObject1() {
    var data = MapButtons_taggedTemplateLiteral([
        "\n  border-radius: 4px;\n  width: 48px;\n  height: 48px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  overflow: hidden;\n  cursor: pointer;\n  background-color: ",
        ";\n  border: 1px solid ",
        ";\n"
    ]);
    MapButtons_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function MapButtons_templateObject2() {
    var data = MapButtons_taggedTemplateLiteral([
        "\n  border-radius: 4px;\n  overflow: hidden;\n  display: flex;\n  width: 48px;\n  flex-direction: column;\n  border: 1px solid ",
        ";\n"
    ]);
    MapButtons_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = MapButtons_taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 48px;\n  height: 48px;\n  background-color: ",
        ";\n  padding: 8px;\n  cursor: pointer;\n  :last-child {\n    border-top: 1px solid ",
        ";\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}






var MapButtons = function(param) {
    var level = param.level, setLevel = param.setLevel, handleClickCurrentLoactionButton = param.handleClickCurrentLoactionButton;
    var levelHandler = function(state) {
        if (state === "minus") {
            if (level !== constants/* SOUTH_KOREA_LEVEL_MAX */.b_6) {
                setLevel(level + 1);
            }
        } else {
            if (level !== 1) {
                setLevel(level - 1);
            }
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(MapButtons_Container, MapButtons_objectSpreadProps(MapButtons_objectSpread({}, tracking/* default.tagGTM */.Z.tagGTM("shop_search")), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonBox, MapButtons_objectSpreadProps(MapButtons_objectSpread({
                onClick: handleClickCurrentLoactionButton
            }, tracking/* default.tagGTM */.Z.tagGTM("shop_search_location_button")), {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* Icongraphy */.Jb, {
                    variant: "ic_my_location",
                    size: 32
                })
            })),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ButtonContainer, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ZoomIconBox, MapButtons_objectSpreadProps(MapButtons_objectSpread({
                        onClick: function() {
                            return levelHandler("plus");
                        }
                    }, tracking/* default.tagGTM */.Z.tagGTM("shop_search_zoom_plus_button")), {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* Icongraphy */.Jb, {
                            variant: "ic_plus_bold",
                            size: 32
                        })
                    })),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ZoomIconBox, MapButtons_objectSpreadProps(MapButtons_objectSpread({
                        onClick: function() {
                            return levelHandler("minus");
                        }
                    }, tracking/* default.tagGTM */.Z.tagGTM("shop_search_zoom_minus_button")), {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* Icongraphy */.Jb, {
                            variant: "ic_minus_bold",
                            size: 32
                        })
                    }))
                ]
            })
        ]
    }));
};
/* harmony default export */ var kakaoMap_MapButtons = (MapButtons);
var MapButtons_Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "MapButtons__Container",
    componentId: "sc-c4b76c70-0"
})(MapButtons_templateObject());
var ButtonBox = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "MapButtons__ButtonBox",
    componentId: "sc-c4b76c70-1"
})(MapButtons_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.colors.natural_color.white;
}, function(param) {
    var theme = param.theme;
    return theme.colors.natural_color.gray[200];
});
var ButtonContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "MapButtons__ButtonContainer",
    componentId: "sc-c4b76c70-2"
})(MapButtons_templateObject2(), function(param) {
    var theme = param.theme;
    return theme.colors.natural_color.gray[200];
});
var ZoomIconBox = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "MapButtons__ZoomIconBox",
    componentId: "sc-c4b76c70-3"
})(_templateObject3(), function(param) {
    var theme = param.theme;
    return theme.colors.natural_color.white;
}, function(param) {
    var theme = param.theme;
    return theme.colors.natural_color.gray[200];
});

;// CONCATENATED MODULE: ./src/feat-components/ShopSearch/Maps/kakaoMap/ClusterBox.tsx
function ClusterBox_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function ClusterBox_templateObject() {
    var data = ClusterBox_taggedTemplateLiteral([
        ""
    ]);
    ClusterBox_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ClusterBox_templateObject1() {
    var data = ClusterBox_taggedTemplateLiteral([
        "\n      width: 120px;\n      height: 120px;\n    "
    ]);
    ClusterBox_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function ClusterBox_templateObject2() {
    var data = ClusterBox_taggedTemplateLiteral([
        "\n      width: 100px;\n      height: 100px;\n    "
    ]);
    ClusterBox_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function ClusterBox_templateObject3() {
    var data = ClusterBox_taggedTemplateLiteral([
        "\n      width: 72px;\n      height: 72px;\n    "
    ]);
    ClusterBox_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = ClusterBox_taggedTemplateLiteral([
        "\n      width: 48px;\n      height: 48px;\n    "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = ClusterBox_taggedTemplateLiteral([
        "\n  color: ",
        ";\n  cursor: pointer;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background-color: ",
        ";\n  opacity: 0.6;\n  border-radius: 50%;\n  ",
        "\n  ",
        ";\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}




var ClusterBox = function(param) {
    var item = param.item, handleClickCluster = param.handleClickCluster;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(OverlayContainer, {
        onClick: function() {
            return handleClickCluster(item);
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_modern/* CustomOverlayMap */.le, {
            position: {
                lat: item.latitude,
                lng: item.longitude
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ClusterContainer, {
                count: item.count,
                children: item.count
            })
        }, "".concat(item.latitude, "-").concat(item.longitude))
    });
};
/* harmony default export */ var kakaoMap_ClusterBox = (ClusterBox);
var OverlayContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "ClusterBox__OverlayContainer",
    componentId: "sc-3d659d0c-0"
})(ClusterBox_templateObject());
var size = function(num) {
    if (num >= 1000) {
        return (0,styled_components_browser_esm/* css */.iv)(ClusterBox_templateObject1());
    } else if (num >= 100) {
        return (0,styled_components_browser_esm/* css */.iv)(ClusterBox_templateObject2());
    } else if (num >= 10) {
        return (0,styled_components_browser_esm/* css */.iv)(ClusterBox_templateObject3());
    } else {
        return (0,styled_components_browser_esm/* css */.iv)(_templateObject4());
    }
};
var ClusterContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "ClusterBox__ClusterContainer",
    componentId: "sc-3d659d0c-1"
})(_templateObject5(), function(param) {
    var theme = param.theme;
    return theme.colors.natural_color.white;
}, function(param) {
    var theme = param.theme;
    return theme.colors.accent_color.secondary.blue;
}, function(param) {
    var count = param.count;
    return size(count);
}, function(param) {
    var theme = param.theme;
    return theme.typography.button_lg_b;
});

// EXTERNAL MODULE: ./src/ui/Icons/MarkerIcon.tsx
var MarkerIcon = __webpack_require__(33488);
;// CONCATENATED MODULE: ./src/ui/Marker/OverlayBox.tsx
function OverlayBox_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function OverlayBox_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            OverlayBox_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function OverlayBox_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function OverlayBox_objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        OverlayBox_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function OverlayBox_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = OverlayBox_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function OverlayBox_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function OverlayBox_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function OverlayBox_templateObject() {
    var data = OverlayBox_taggedTemplateLiteral([
        "\n  cursor: pointer;\n"
    ]);
    OverlayBox_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function OverlayBox_templateObject1() {
    var data = OverlayBox_taggedTemplateLiteral([
        "\n  display: flex;\n  padding: 3px 12px 3px 0px;\n  border-radius: 100px;\n  border: 1px solid ",
        ";\n  height: 46px;\n  z-index: 999;\n  align-items: center;\n  background-color: ",
        ";\n  svg {\n    position: relative;\n    left: -2px;\n  }\n"
    ]);
    OverlayBox_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function OverlayBox_templateObject2() {
    var data = OverlayBox_taggedTemplateLiteral([
        "\n  height: 18px;\n  width: 12px;\n  position: absolute;\n  bottom: -18px;\n  left: 35px;\n  border-bottom: 0px solid transparent;\n  border-top: 8px solid ",
        ";\n  border-left: 6px solid transparent;\n  border-right: 6px solid transparent;\n"
    ]);
    OverlayBox_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function OverlayBox_templateObject3() {
    var data = OverlayBox_taggedTemplateLiteral([
        "\n  max-width: 208px;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  color: ",
        ";\n  ",
        ";\n"
    ]);
    OverlayBox_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function OverlayBox_templateObject4() {
    var data = OverlayBox_taggedTemplateLiteral([
        "\n  width: 49px;\n  height: 49px;\n  border-radius: 50%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  svg {\n    position: relative;\n    top: -1px;\n    left: -1px;\n  }\n"
    ]);
    OverlayBox_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function OverlayBox_templateObject5() {
    var data = OverlayBox_taggedTemplateLiteral([
        "\n  width: 49px;\n  height: 50px;\n"
    ]);
    OverlayBox_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}





var OverlayBox = function(_param) {
    var item = _param.item, currentHover = _param.currentHover, props = OverlayBox_objectWithoutProperties(_param, [
        "item",
        "currentHover"
    ]);
    var isHover = currentHover === item.id;
    var iconProps = {
        isHover: isHover,
        groupCode: item.type.groupCode
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(MarkerContainer, OverlayBox_objectSpreadProps(OverlayBox_objectSpread({}, props), {
        children: isHover ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(OverlayBox_Container, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(MarkerIcon/* default */.Z, OverlayBox_objectSpreadProps(OverlayBox_objectSpread({}, iconProps), {
                    fill: styles/* theme.colors.accent_colors.blue.default */.rS.colors.accent_colors.blue["default"]
                })),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(StoreName, {
                    children: item.name
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowIcon, {})
            ]
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(MarkerBox, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(OverlayBox_IconBox, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MarkerIcon/* default */.Z, OverlayBox_objectSpreadProps(OverlayBox_objectSpread({}, iconProps), {
                    fill: styles/* theme.colors.accent_colors.primary.default */.rS.colors.accent_colors.primary["default"]
                }))
            })
        })
    }));
};
/* harmony default export */ var Marker_OverlayBox = (OverlayBox);
var MarkerContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "OverlayBox__MarkerContainer",
    componentId: "sc-b039ad8e-0"
})(OverlayBox_templateObject());
var OverlayBox_Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "OverlayBox__Container",
    componentId: "sc-b039ad8e-1"
})(OverlayBox_templateObject1(), styles/* theme.colors.accent_colors.primary.default */.rS.colors.accent_colors.primary["default"], styles/* theme.colors.neutral_colors.white */.rS.colors.neutral_colors.white);
var ArrowIcon = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "OverlayBox__ArrowIcon",
    componentId: "sc-b039ad8e-2"
})(OverlayBox_templateObject2(), styles/* theme.colors.accent_colors.primary.default */.rS.colors.accent_colors.primary["default"]);
var StoreName = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "OverlayBox__StoreName",
    componentId: "sc-b039ad8e-3"
})(OverlayBox_templateObject3(), styles/* theme.colors.accent_colors.primary.default */.rS.colors.accent_colors.primary["default"], styles/* theme.typography.button.lg_b */.rS.typography.button.lg_b);
var OverlayBox_IconBox = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "OverlayBox__IconBox",
    componentId: "sc-b039ad8e-4"
})(OverlayBox_templateObject4());
var MarkerBox = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "OverlayBox__MarkerBox",
    componentId: "sc-b039ad8e-5"
})(OverlayBox_templateObject5());

;// CONCATENATED MODULE: ./src/ui/Marker/Marker.tsx
function Marker_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function Marker_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            Marker_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function Marker_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = Marker_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function Marker_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function Marker_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function Marker_templateObject() {
    var data = Marker_taggedTemplateLiteral([
        ""
    ]);
    Marker_templateObject = function _templateObject() {
        return data;
    };
    return data;
}






var Marker = function(_param) {
    var item = _param.item, hoverItem = _param.hoverItem, setHoverItem = _param.setHoverItem, props = Marker_objectWithoutProperties(_param, [
        "item",
        "hoverItem",
        "setHoverItem"
    ]);
    // 매장 위치정보 보내기
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
        href: "/shop/".concat(item.id),
        passHref: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Marker_OverlayContainer, {
            onMouseOver: function() {
                return setHoverItem && setHoverItem(item.id);
            },
            onMouseLeave: function() {
                return setHoverItem && setHoverItem(null);
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_modern/* CustomOverlayMap */.le, {
                position: {
                    lat: item.address.coordinates.latitude,
                    lng: item.address.coordinates.longitude
                },
                zIndex: item.id === hoverItem ? 999 : 99,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Marker_OverlayBox, Marker_objectSpread({
                    item: item,
                    currentHover: hoverItem
                }, props))
            }, "".concat(item.address.coordinates.latitude, "-").concat(item.address.coordinates.longitude))
        })
    });
};
/* harmony default export */ var Marker_Marker = (Marker);
var Marker_OverlayContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "Marker__OverlayContainer",
    componentId: "sc-a7e3751d-0"
})(Marker_templateObject());

;// CONCATENATED MODULE: ./src/ui/Marker/index.ts


;// CONCATENATED MODULE: ./src/feat-components/ShopSearch/Maps/kakaoMap/KakaoMap.tsx
function KakaoMap_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function KakaoMap_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            KakaoMap_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function KakaoMap_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function KakaoMap_objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        KakaoMap_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function KakaoMap_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function KakaoMap_templateObject() {
    var data = KakaoMap_taggedTemplateLiteral([
        "\n  flex: 1;\n  width: 100%;\n  height: 100%;\n  top: 0px;\n  left: 0px;\n  position: relative;\n"
    ]);
    KakaoMap_templateObject = function _templateObject() {
        return data;
    };
    return data;
}










var KakaoMap = /*#__PURE__*/ (0,react.forwardRef)(function KakaoMap(param, ref) {
    var level = param.level, center = param.center, // currentMarker,
    // totalPage,
    // currentPage,
    clusterListApiData = param.clusterListApiData, // markerTotalCount,
    markerListApiData = param.markerListApiData, isShowReSearchButton = param.isShowReSearchButton, // isCommonMainShop,
    hoverItem = param.hoverItem, setHoverItem = param.setHoverItem, setLevel = param.setLevel, handleClickReSearchButton = param.handleClickReSearchButton, // handleClickMoreMapButton,
    handleClickCurrentLoactionButton = param.handleClickCurrentLoactionButton, handleClickCluster = param.handleClickCluster, handleChangeCenter = param.handleChangeCenter;
    var props = {
        ref: ref
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(MapContainer, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_modern/* Map */.D5, KakaoMap_objectSpreadProps(KakaoMap_objectSpread({
                center: {
                    lat: center === null || center === void 0 ? void 0 : center.latitude,
                    lng: center === null || center === void 0 ? void 0 : center.longitude
                },
                style: {
                    width: "100%",
                    height: "100%"
                },
                maxLevel: constants/* SOUTH_KOREA_LEVEL_MAX */.b_6,
                level: level,
                onZoomChanged: function(map) {
                    return setLevel(map.getLevel());
                },
                onCenterChanged: handleChangeCenter
            }, props), {
                children: [
                    level <= 10 && (markerListApiData === null || markerListApiData === void 0 ? void 0 : markerListApiData.map(function(item) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Marker_Marker, KakaoMap_objectSpread({
                            item: item,
                            hoverItem: hoverItem,
                            setHoverItem: setHoverItem
                        }, tracking/* default.tagGTM */.Z.tagGTM("shop_search_shop_detail_marker_button", {
                            "shop-id": item.id
                        })), item.id);
                    })),
                    level >= 11 && (clusterListApiData === null || clusterListApiData === void 0 ? void 0 : clusterListApiData.map(function(item) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(kakaoMap_ClusterBox, KakaoMap_objectSpread({
                            item: item,
                            handleClickCluster: handleClickCluster
                        }, tracking/* default.tagGTM */.Z.tagGTM("shop_search_cluster_button")), "".concat(item.latitude, "_").concat(item.longitude));
                    }))
                ]
            })),
            isShowReSearchButton && level !== constants/* SOUTH_KOREA_LEVEL_MAX */.b_6 && /*#__PURE__*/ (0,jsx_runtime.jsx)(kakaoMap_BtnMapRefresh, KakaoMap_objectSpread({
                onClick: handleClickReSearchButton
            }, tracking/* default.tagGTM */.Z.tagGTM("shop_search_research_map_button"))),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(kakaoMap_MapButtons, {
                level: level,
                setLevel: setLevel,
                handleClickCurrentLoactionButton: handleClickCurrentLoactionButton
            })
        ]
    });
});
/* harmony default export */ var kakaoMap_KakaoMap = (KakaoMap);
var MapContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "KakaoMap__MapContainer",
    componentId: "sc-d7c5d198-0"
})(KakaoMap_templateObject());

// EXTERNAL MODULE: ./src/ui/ErrorMessage/index.ts + 1 modules
var ErrorMessage = __webpack_require__(44542);
// EXTERNAL MODULE: ./src/styles/common.ts
var common = __webpack_require__(47046);
// EXTERNAL MODULE: ./src/utils/index.ts
var utils = __webpack_require__(67748);
// EXTERNAL MODULE: ../../.yarn/__virtual__/next-virtual-769137b2ab/0/cache/next-npm-12.2.3-07d597c2b7-b13b42fbb3.zip/node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(1861);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ../../.yarn/cache/query-string-npm-7.1.1-55c6f31f52-b227d1f588.zip/node_modules/query-string/index.js
var query_string = __webpack_require__(46757);
// EXTERNAL MODULE: ../../.yarn/cache/lodash-npm-4.17.21-6382451519-eb835a2e51.zip/node_modules/lodash/lodash.js
var lodash = __webpack_require__(35735);
var lodash_default = /*#__PURE__*/__webpack_require__.n(lodash);
// EXTERNAL MODULE: ../../.yarn/__virtual__/swr-virtual-b8afd7b304/0/cache/swr-npm-1.3.0-3a8f9fadf5-e7a184f0d5.zip/node_modules/swr/infinite/dist/index.mjs
var dist = __webpack_require__(38458);
// EXTERNAL MODULE: ../../.yarn/__virtual__/swr-virtual-b8afd7b304/0/cache/swr-npm-1.3.0-3a8f9fadf5-e7a184f0d5.zip/node_modules/swr/dist/index.mjs
var swr_dist = __webpack_require__(98749);
// EXTERNAL MODULE: ./src/di-container/shop/search/gateway/client.ts
var client = __webpack_require__(59153);
// EXTERNAL MODULE: ../../.yarn/__virtual__/next-virtual-769137b2ab/0/cache/next-npm-12.2.3-07d597c2b7-b13b42fbb3.zip/node_modules/next/router.js
var next_router = __webpack_require__(71975);
// EXTERNAL MODULE: ./src/providers/WebProvider/WebProvider.tsx + 1 modules
var WebProvider = __webpack_require__(90516);
// EXTERNAL MODULE: ./src/redux/reducers/shopSearch.ts
var shopSearch = __webpack_require__(19175);
// EXTERNAL MODULE: ../../.yarn/__virtual__/react-redux-virtual-d8cdb1e912/0/cache/react-redux-npm-8.0.4-ee216b0e53-fd940de6a6.zip/node_modules/react-redux/es/index.js + 13 modules
var es = __webpack_require__(65703);
// EXTERNAL MODULE: ./src/hooks/useWindowHistory.ts
var useWindowHistory = __webpack_require__(34251);
// EXTERNAL MODULE: ./src/di-container/ip/gateway/client.ts
var gateway_client = __webpack_require__(53644);
// EXTERNAL MODULE: ./src/di-container/shop/geo-location/client.ts
var geo_location_client = __webpack_require__(63401);
;// CONCATENATED MODULE: ./src/feat-components/ShopSearch/hooks/useMaps.ts
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function useMaps_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function useMaps_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            useMaps_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function useMaps_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function useMaps_objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        useMaps_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
















var REMODELING_SHOP = "/shop/search";
var CALLBACK_ID_GET_LOCATION = "getLocation";
var useMaps = function(param) {
    var sidoList = param.sidoList, address = param.address, st = param.st;
    var ref;
    var router = (0,next_router.useRouter)();
    var store = (0,es/* useStore */.oR)();
    var handleGetLocation = (0,WebProvider/* useWeb */.C)().handleGetLocation;
    var handleReplaceState = (0,useWindowHistory/* default */.Z)().handleReplaceState;
    // const [init, setInit] = useState<number>(0);
    var ref1 = (0,react.useState)(true), openState = ref1[0], setOpenState = ref1[1];
    var ref2 = (0,react.useState)(true), isLoading = ref2[0], setIsLoading = ref2[1];
    var ref3 = (0,react.useState)(1), pages = ref3[0], setPages = ref3[1];
    var urlParam = (0,es/* useSelector */.v9)(shopSearch/* selectShopSearchUrlParam */.MB);
    var ref4;
    var ref5 = (0,react.useState)((ref4 = urlParam === null || urlParam === void 0 ? void 0 : urlParam.zoomLevel) !== null && ref4 !== void 0 ? ref4 : constants/* SOUTH_KOREA_LEVEL_MAX */.b_6), level = ref5[0], setLevel = ref5[1];
    var ref6, ref7;
    var ref8 = (0,react.useState)({
        latitude: (ref6 = urlParam === null || urlParam === void 0 ? void 0 : urlParam.latitude) !== null && ref6 !== void 0 ? ref6 : constants/* SOUTH_KOREA_LAT */.keB,
        longitude: (ref7 = urlParam === null || urlParam === void 0 ? void 0 : urlParam.longitude) !== null && ref7 !== void 0 ? ref7 : constants/* SOUTH_KOREA_LNG */.SRH
    }), center = ref8[0], setCenter = ref8[1];
    var mapRef = (0,react.useRef)();
    var isApiCall = (0,react.useRef)({
        postGeoLocation: false
    });
    var realMapRef = (0,react.useMemo)(function() {
        return mapRef.current ? mapRef.current : undefined;
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        mapRef.current
    ]);
    var ref9 = (0,react.useState)(null), hoverItem = ref9[0], setHoverItem = ref9[1];
    var ref10 = (0,react.useState)(), area = ref10[0], setArea = ref10[1];
    var ref11 = (0,react.useState)(undefined), sido = ref11[0], setSido = ref11[1];
    var ref12 = (0,react.useState)(undefined), gungu = ref12[0], setGungu = ref12[1];
    var ref13 = (0,react.useState)({
        id: 0,
        text: "전체",
        code: "ALL"
    }), groupCode = ref13[0], setGroupCode = ref13[1];
    var ref14 = (0,react.useState)([]), itemTypes = ref14[0], setItemTypes = ref14[1];
    var ref15 = (0,react.useState)(false), isShowReSearchButton = ref15[0], setIsShowReSearchButton = ref15[1];
    var ref16 = (0,react.useState)(undefined), isDenied = ref16[0], setIsDenied = ref16[1];
    var isCommonMainShop = (0,react.useMemo)(function() {
        return router.pathname === REMODELING_SHOP;
    }, [
        router.pathname
    ]);
    /**
   * API
   */ var ref17 = (0,react.useState)(false), isAutoFitZoom = ref17[0], setAutoFitZoom = ref17[1];
    // ========= 매장 목록 API START =========
    var getShopListKey = (0,react.useCallback)(function(pageIndex) {
        if (level < 12) {
            return query_string.stringify(useMaps_objectSpreadProps(useMaps_objectSpread({
                page: pages,
                size: 10
            }, area), {
                groupCode: isCommonMainShop ? undefined : groupCode.code,
                itemTypes: isCommonMainShop ? itemTypes.length > 0 ? itemTypes.map(function(x) {
                    return x.code;
                }) : constants/* SHOP_ITEM_TYPE.map */.qws.map(function(x) {
                    return x.code;
                }) : undefined
            }));
        } else {
            return query_string.stringify({
                page: pages,
                size: 10,
                groupCode: isCommonMainShop ? undefined : groupCode.code,
                itemTypes: isCommonMainShop ? itemTypes.length > 0 ? itemTypes.map(function(x) {
                    return x.code;
                }) : constants/* SHOP_ITEM_TYPE.map */.qws.map(function(x) {
                    return x.code;
                }) : undefined
            });
        }
    }, [
        area,
        groupCode.code,
        isCommonMainShop,
        itemTypes,
        level,
        pages
    ]);
    /**
   * Uri 업데이트
   */ var updateUri = (0,react.useCallback)(function(param) {
        var latitude = param.latitude, longitude = param.longitude, zoomLevel = param.zoomLevel;
        if (latitude && longitude && zoomLevel) {
            store.dispatch((0,shopSearch/* setShopSearchUrlParam */.I3)({
                latitude: latitude,
                longitude: longitude,
                zoomLevel: zoomLevel
            }));
            handleReplaceState(null, "", tracking/* default.retainQueryParam */.Z.retainQueryParam("".concat(router.pathname), {
                lat: latitude,
                lng: longitude,
                level: zoomLevel
            }));
        }
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        handleReplaceState,
        store
    ]);
    var ref18 = (0,dist/* default */.ZP)(function(pageIndex, previousPageData) {
        var ref;
        if (previousPageData && ((ref = previousPageData.data) === null || ref === void 0 ? void 0 : ref.content.length) === 0) return null;
        return getShopListKey(pageIndex, previousPageData);
    }, function(query) {
        // setInit((prev) => prev + 1);
        setIsLoading(true);
        return (0,client/* shopSearchGateway */.q)().getShopListData.exec(useMaps_objectSpread({}, query_string.parse(query)));
    }), markerListApi = ref18.data;
    var markerListApiData = (0,react.useMemo)(function() {
        var response = markerListApi === null || markerListApi === void 0 ? void 0 : markerListApi.map(function(response) {
            var ref;
            return response === null || response === void 0 ? void 0 : (ref = response.data) === null || ref === void 0 ? void 0 : ref.content;
        });
        if ((markerListApi === null || markerListApi === void 0 ? void 0 : markerListApi[0].code) === 200) {
            setIsLoading(false);
            setOpenState(true);
            setIsShowReSearchButton(false);
        }
        return (response === null || response === void 0 ? void 0 : response.reduce(function() {
            var prev = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], accumulator = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
            return prev.concat(accumulator);
        })) || [];
    }, [
        markerListApi
    ]);
    var shopListNumber = (0,react.useMemo)(function() {
        var ref;
        var response = (ref = markerListApi === null || markerListApi === void 0 ? void 0 : markerListApi.find(function(response) {
            return response === null || response === void 0 ? void 0 : response.data;
        })) === null || ref === void 0 ? void 0 : ref.data;
        return {
            totalElements: response === null || response === void 0 ? void 0 : response.totalElements,
            totalPages: response === null || response === void 0 ? void 0 : response.totalPages
        };
    }, [
        markerListApi
    ]);
    // ========= 필터 관련 훅 START =========
    var handleClickItemTypes = (0,react.useCallback)(function() {
        var _ref = _asyncToGenerator(runtime_default().mark(function _callee(param) {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (itemTypes.find(function(x) {
                            return x === param;
                        }) === undefined) {
                            setItemTypes(_toConsumableArray(itemTypes).concat([
                                param
                            ]));
                        } else {
                            setItemTypes(itemTypes.filter(function(x) {
                                return x !== param;
                            }));
                        }
                    case 1:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(param) {
            return _ref.apply(this, arguments);
        };
    }(), [
        itemTypes
    ]);
    var handleClickItemTypesReset = (0,react.useCallback)(_asyncToGenerator(runtime_default().mark(function _callee() {
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    setItemTypes([]);
                    setGroupCode({
                        code: "ALL",
                        id: 0
                    });
                case 2:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    })), []);
    var handleChangegroupCode = (0,react.useCallback)(function() {
        var _ref = _asyncToGenerator(runtime_default().mark(function _callee(selectedItem) {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (selectedItem.code === groupCode.code) {
                            setGroupCode({
                                id: 0,
                                text: "전체",
                                code: "ALL"
                            });
                        } else {
                            setGroupCode(selectedItem);
                        }
                    case 1:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(selectedItem) {
            return _ref.apply(this, arguments);
        };
    }(), [
        groupCode
    ]);
    // ========= 필터 관련 훅 END =========
    // ========= 매장 목록 API END =========
    // ========= 클러스터 API START =========
    var getClusterKey = (0,react.useCallback)(function(pageIndex) {
        return level >= constants/* SOUTH_KOREA_LEVEL_MIN */.nCe ? query_string.stringify({
            groupCode: isCommonMainShop ? undefined : groupCode.code,
            itemTypes: isCommonMainShop ? itemTypes.length > 0 ? itemTypes.map(function(x) {
                return x.code;
            }) : constants/* SHOP_ITEM_TYPE.map */.qws.map(function(x) {
                return x.code;
            }) : undefined
        }) : null;
    }, [
        groupCode,
        isCommonMainShop,
        itemTypes,
        level
    ]);
    var ref19 = (0,dist/* default */.ZP)(getClusterKey, function(query) {
        return (0,client/* shopSearchGateway */.q)().getShopClusterListData.exec(useMaps_objectSpread({}, query_string.parse(query)));
    }), clusterList = ref19.data;
    var clusterListApiData = (0,react.useMemo)(function() {
        var ref;
        if ((clusterList === null || clusterList === void 0 ? void 0 : clusterList[0].code) !== 200) {
            return undefined;
        }
        return (ref = clusterList === null || clusterList === void 0 ? void 0 : clusterList[0].data) === null || ref === void 0 ? void 0 : ref.clusters;
    }, [
        clusterList
    ]);
    // ========= 클러스터 API END =========
    var ref20 = (0,react.useState)(false), isSearchLoading = ref20[0], setIsSearchLoading = ref20[1];
    (0,react.useEffect)(function() {
        if (!isSearchLoading) return;
        // if (isAutoFitZoom) return;
        changeShopList();
        setIsSearchLoading(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isSearchLoading
    ]);
    // 시,도 변경 이벤트
    var handleChangeSido = (0,react.useCallback)(function(e) {
        var _dataset = e.currentTarget.dataset, name = _dataset.custom_field_1, code = _dataset.custom_field_2, latitude = _dataset.custom_field_3, longitude = _dataset.custom_field_4;
        if (name && code && latitude && longitude) {
            setSido({
                name: name,
                code: code,
                latitude: Number(latitude),
                longitude: Number(longitude)
            });
            setGungu(undefined);
            // mapRef.current?.setCenter(
            //   new window.kakao.maps.LatLng(Number(latitude), Number(longitude)),
            // );
            // mapRef.current?.setLevel(SI_DO_LEVEL);
            updateUri({
                latitude: Number(latitude),
                longitude: Number(longitude),
                zoomLevel: constants/* SI_DO_LEVEL */.nUO
            });
        } else {
            var ref, ref1;
            setSido(undefined);
            setGungu(undefined);
            (ref = mapRef.current) === null || ref === void 0 ? void 0 : ref.setCenter(new window.kakao.maps.LatLng(Number(constants/* SOUTH_KOREA_LAT */.keB), Number(constants/* SOUTH_KOREA_LNG */.SRH)));
            (ref1 = mapRef.current) === null || ref1 === void 0 ? void 0 : ref1.setLevel(constants/* SOUTH_KOREA_LEVEL_MAX */.b_6);
        }
    }, [
        updateUri
    ]);
    // 군,구 변경 이벤트
    var handleChangeGunGu = (0,react.useCallback)(function(e) {
        var _dataset = e.currentTarget.dataset, name = _dataset.custom_field_1, code = _dataset.custom_field_2, latitude = _dataset.custom_field_3, longitude = _dataset.custom_field_4;
        if (name && code && latitude && longitude) {
            setGungu({
                name: name,
                code: code,
                latitude: Number(latitude),
                longitude: Number(longitude)
            });
            // mapRef.current?.setCenter(
            //   new window.kakao.maps.LatLng(Number(latitude), Number(longitude)),
            // );
            // mapRef.current?.setLevel(GUN_GU_LEVEL);
            updateUri({
                latitude: Number(latitude),
                longitude: Number(longitude),
                zoomLevel: constants/* GUN_GU_LEVEL */.yO9
            });
        } else {
            setGungu(undefined);
            if (sido) {
                var ref, ref1;
                (ref = mapRef.current) === null || ref === void 0 ? void 0 : ref.setCenter(new window.kakao.maps.LatLng(Number(sido.latitude), Number(sido.longitude)));
                (ref1 = mapRef.current) === null || ref1 === void 0 ? void 0 : ref1.setLevel(constants/* SI_DO_LEVEL */.nUO);
            }
        }
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        sido
    ]);
    // ========= 시,도 API Format START =========
    var convertSidoDropdownOptionFormat = (0,react.useMemo)(function() {
        return (sidoList === null || sidoList === void 0 ? void 0 : sidoList.map(function(obj) {
            return {
                text: obj.name,
                value: obj.code,
                customProps: {
                    "data-custom_field_1": obj.name,
                    "data-custom_field_2": obj.code,
                    "data-custom_field_3": lodash_default().toString(obj.latitude),
                    "data-custom_field_4": lodash_default().toString(obj.longitude)
                }
            };
        })) || [];
    }, [
        sidoList
    ]);
    // ========= 시,도 API Format END =========
    // ========= 군구 목록 API START =========
    var gunGuFetchear = function() {
        var _ref = _asyncToGenerator(runtime_default().mark(function _callee() {
            var res;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return (0,client/* shopSearchGateway */.q)().getGunGuData.exec({
                            code: sido === null || sido === void 0 ? void 0 : sido.code
                        });
                    case 2:
                        res = _ctx.sent;
                        if (res.code !== 200) {
                        // console.log(res.code, res.message);
                        }
                        return _ctx.abrupt("return", res);
                    case 5:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function gunGuFetchear() {
            return _ref.apply(this, arguments);
        };
    }();
    var ref21 = (0,swr_dist/* default */.ZP)(sido ? "/sido/".concat(sido.code) : null, gunGuFetchear), gunguListApi = ref21.data;
    var convertGunGuDropdownOptionFormat = (0,react.useMemo)(function() {
        var ref;
        return (gunguListApi === null || gunguListApi === void 0 ? void 0 : (ref = gunguListApi.data) === null || ref === void 0 ? void 0 : ref.gunGus.map(function(obj) {
            return {
                text: obj.name,
                value: obj.code,
                customProps: {
                    "data-custom_field_1": obj.name,
                    "data-custom_field_2": obj.code,
                    "data-custom_field_3": lodash_default().toString(obj.latitude),
                    "data-custom_field_4": lodash_default().toString(obj.longitude)
                }
            };
        })) || [];
    }, [
        gunguListApi === null || gunguListApi === void 0 ? void 0 : (ref = gunguListApi.data) === null || ref === void 0 ? void 0 : ref.gunGus
    ]);
    // ========= 군구 목록 API END =========
    var changeShopList = (0,react.useCallback)(_asyncToGenerator(runtime_default().mark(function _callee() {
        var proj, bounds, sw, ne, mapBoundWithoutBottomSheet;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    if (realMapRef) {
                        _ctx.next = 2;
                        break;
                    }
                    return _ctx.abrupt("return");
                case 2:
                    proj = realMapRef.getProjection();
                    bounds = realMapRef.getBounds();
                    sw = proj.pointFromCoords(bounds.getSouthWest());
                    ne = proj.pointFromCoords(bounds.getNorthEast());
                    mapBoundWithoutBottomSheet = new window.kakao.maps.LatLngBounds(proj.coordsFromPoint(sw), proj.coordsFromPoint(ne));
                    _ctx.next = 9;
                    return setArea({
                        cenLatitude: center.latitude,
                        cenLongitude: center.longitude,
                        neLatitude: mapBoundWithoutBottomSheet.getNorthEast().getLat(),
                        neLongitude: mapBoundWithoutBottomSheet.getNorthEast().getLng(),
                        swLatitude: mapBoundWithoutBottomSheet.getSouthWest().getLat(),
                        swLongitude: mapBoundWithoutBottomSheet.getSouthWest().getLng()
                    });
                case 9:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    })), [
        center.latitude,
        center.longitude,
        realMapRef
    ]);
    var handleClickReSearchButton = (0,react.useCallback)(_asyncToGenerator(runtime_default().mark(function _callee() {
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    changeShopList();
                case 1:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    })), [
        changeShopList
    ]);
    var handleChangeCenter = (0,react.useCallback)(function(map) {
        setAutoFitZoom(false);
        setCenter({
            latitude: map.getCenter().getLat(),
            longitude: map.getCenter().getLng()
        });
        updateUri({
            latitude: map.getCenter().getLat(),
            longitude: map.getCenter().getLng(),
            zoomLevel: map.getLevel()
        });
        if (!isAutoFitZoom) {
            setIsShowReSearchButton(true);
        }
    }, [
        isAutoFitZoom,
        updateUri
    ]);
    /**
   * 주어진 영역이 화면 안에 검색된 매장이 전부 나타날 수 있도록 지도의 중심 좌표와 확대 수준을 설정
   */ // const handleFitMarkersToBounds = useCallback(async () => {
    //   // 시도, 군구 코드정보만으로 검색한 매장 리스트 조회
    //   const response = await shopSearchGateway().getShopListData.exec({
    //     page: pages || 1,
    //     size: 10,
    //     sidoCd: sido?.code,
    //     sggCd: gungu?.code,
    //     itemTypes: [],
    //     groupCode: 'ALL',
    //   });
    //   // 각 매장 리스트의 위도, 경도 정보를 기준으로 지도의 중심점을 설정
    //   const points = response.data?.content.map(
    //     (shop) =>
    //       new window.kakao.maps.LatLng(
    //         shop.address.coordinates.latitude,
    //         shop.address.coordinates.longitude,
    //       ),
    //   );
    //   const bounds = new window.kakao.maps.LatLngBounds();
    //   points?.forEach((point) => {
    //     bounds.extend(point);
    //   });
    //   // 지도에 설정된 중심점을 변경
    //   mapRef.current?.setBounds(bounds);
    //   changeShopList();
    // }, [changeShopList, gungu?.code, pages, sido?.code]);
    /**
   * 지도검색 버튼 클릭 이벤트
   */ var handleClickMapSearchButton = (0,react.useCallback)(_asyncToGenerator(runtime_default().mark(function _callee() {
        var // handleFitMarkersToBounds();
        ref, ref1, ref2;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    setIsSearchLoading(true);
                    setAutoFitZoom(true);
                    if (!(sido && sido.code === "50")) {
                        _ctx.next = 7;
                        break;
                    }
                    ;
                    (ref = mapRef.current) === null || ref === void 0 ? void 0 : ref.setLevel(constants/* SI_DO_LEVEL */.nUO);
                    setCenter({
                        latitude: sido.latitude - 0.2,
                        longitude: sido.longitude
                    });
                    return _ctx.abrupt("return");
                case 7:
                    if (sido && !gungu) {
                        ;
                        (ref1 = mapRef.current) === null || ref1 === void 0 ? void 0 : ref1.setLevel(constants/* SI_DO_LEVEL */.nUO);
                        setCenter({
                            latitude: sido.latitude,
                            longitude: sido.longitude
                        });
                    }
                    if (sido && gungu) {
                        ;
                        (ref2 = mapRef.current) === null || ref2 === void 0 ? void 0 : ref2.setLevel(constants/* GUN_GU_LEVEL */.yO9);
                        setCenter({
                            latitude: gungu.latitude,
                            longitude: gungu.longitude
                        });
                    }
                case 9:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    })), [
        gungu,
        sido
    ]);
    var handleChangePages = (0,react.useCallback)(function(nextPage) {
        setPages(nextPage);
    }, []);
    var handleChangeDebounceCenter = (0,lodash.debounce)(function(map) {
        handleChangeCenter(map);
    }, 200);
    var handleClickCluster = (0,react.useCallback)(function(coordinates) {
        var ref, ref1;
        (ref = mapRef.current) === null || ref === void 0 ? void 0 : ref.setCenter(new window.kakao.maps.LatLng(coordinates.latitude, coordinates.longitude));
        (ref1 = mapRef.current) === null || ref1 === void 0 ? void 0 : ref1.setLevel(constants/* SI_DO_LEVEL */.nUO);
    }, []);
    var showCurrentMarker = (0,react.useCallback)(function(latitude, longitude) {
        var ref, ref1;
        (ref = mapRef.current) === null || ref === void 0 ? void 0 : ref.setCenter(new window.kakao.maps.LatLng(latitude, longitude));
        (ref1 = mapRef.current) === null || ref1 === void 0 ? void 0 : ref1.setLevel(constants/* CURRENT_LEVEL */.xEJ);
    }, []);
    var getLocation = (0,react.useCallback)(function() {
        var _ref = _asyncToGenerator(runtime_default().mark(function _callee(message) {
            var latitude, longitude;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (message.code === 200 && message.data) {
                            if (!isApiCall.current.postGeoLocation) {
                                isApiCall.current.postGeoLocation = true;
                                (0,gateway_client/* searchAddressIpGateway */.d)().getSearchIp.exec().then(function(res) {
                                    var result = res;
                                    if (result.code === 200) {
                                        var ref;
                                        var req = {
                                            ip: ((ref = result.data) === null || ref === void 0 ? void 0 : ref.ivIp) || "",
                                            pageAreaCode: isCommonMainShop ? "MAIN" : "RH"
                                        };
                                        (0,geo_location_client/* shopGeoLocationGateway */.R)().postGeoLocation.exec(req);
                                    }
                                    isApiCall.current.postGeoLocation = false;
                                }).catch(function() {
                                    isApiCall.current.postGeoLocation = false;
                                });
                            }
                            latitude = message.data.latitude;
                            longitude = message.data.longitude;
                            showCurrentMarker(latitude, longitude);
                            setIsDenied(false);
                        } else {
                            if (isDenied === undefined) {
                                setIsDenied(true);
                            }
                        }
                    case 1:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(message) {
            return _ref.apply(this, arguments);
        };
    }(), [
        isCommonMainShop,
        isDenied,
        showCurrentMarker
    ]);
    var handleClickCurrentLoactionButton = (0,react.useCallback)(function() {
        handleGetLocation(CALLBACK_ID_GET_LOCATION, getLocation);
    }, [
        getLocation,
        handleGetLocation
    ]);
    var handleToggleMenu = (0,react.useCallback)(function() {
        setOpenState(function(pre) {
            return !pre;
        });
        setTimeout(function() {
            realMapRef.relayout();
        }, 250);
    }, [
        realMapRef
    ]);
    // 페이지네이션 초기화
    (0,react.useEffect)(function() {
        setPages(1);
    }, [
        area,
        sido,
        gungu,
        groupCode,
        itemTypes
    ]);
    (0,react.useEffect)(function() {
        var findShopFilter = lodash_default().find(constants/* SHOP_REMODELING_FILTER */.EEt, {
            code: st.toLocaleUpperCase()
        });
        if (findShopFilter) {
            setGroupCode(findShopFilter);
        }
    }, [
        st
    ]);
    (0,react.useEffect)(function() {
        handleGetLocation(null, getLocation);
    }, [
        getLocation,
        handleGetLocation
    ]);
    return {
        center: center,
        openState: openState,
        level: level,
        mapRef: mapRef,
        isShowReSearchButton: isShowReSearchButton,
        markerListApiData: markerListApiData,
        hoverItem: hoverItem,
        shopListNumber: shopListNumber,
        sido: sido,
        gungu: gungu,
        setSido: setSido,
        setGungu: setGungu,
        groupCode: groupCode,
        itemTypes: itemTypes,
        pages: pages,
        isLoading: isLoading,
        convertSidoDropdownOptionFormat: convertSidoDropdownOptionFormat,
        convertGunGuDropdownOptionFormat: convertGunGuDropdownOptionFormat,
        clusterListApiData: clusterListApiData,
        setOpenState: setOpenState,
        handleClickItemTypes: handleClickItemTypes,
        handleClickItemTypesReset: handleClickItemTypesReset,
        handleClickCurrentLoactionButton: handleClickCurrentLoactionButton,
        handleChangegroupCode: handleChangegroupCode,
        handleClickCluster: handleClickCluster,
        setHoverItem: setHoverItem,
        setLevel: setLevel,
        setPages: setPages,
        handleChangeDebounceCenter: handleChangeDebounceCenter,
        handleClickReSearchButton: handleClickReSearchButton,
        handleChangeSido: handleChangeSido,
        handleChangeGunGu: handleChangeGunGu,
        handleClickMapSearchButton: handleClickMapSearchButton,
        handleToggleMenu: handleToggleMenu,
        handleChangePages: handleChangePages
    };
};
/* harmony default export */ var hooks_useMaps = (useMaps);

;// CONCATENATED MODULE: ./src/feat-components/ShopSearch/Maps/Maps.tsx
function Maps_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function Maps_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            Maps_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function Maps_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function Maps_objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        Maps_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function Maps_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function Maps_templateObject() {
    var data = Maps_taggedTemplateLiteral([
        "\n  width: 100%;\n  position: sticky;\n  display: flex;\n  top: 0px;\n  bottom: 0px;\n  left: 0px;\n"
    ]);
    Maps_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Maps_templateObject1() {
    var data = Maps_taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  position: relative;\n  /* transition: 0.4s; */\n  height: 100%;\n  z-index: 9999;\n"
    ]);
    Maps_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function Maps_templateObject2() {
    var data = Maps_taggedTemplateLiteral([
        "\n  width: 100%;\n  margin-top: 80px;\n  padding: 24px 28px;\n  display: flex;\n  justify-content: center;\n"
    ]);
    Maps_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function Maps_templateObject3() {
    var data = Maps_taggedTemplateLiteral([
        "\n  width: 454px;\n  height: 100%;\n  animation-fill-mode: forwards;\n  flex-direction: column;\n  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.25);\n  z-index: 1;\n"
    ]);
    Maps_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function Maps_templateObject4() {
    var data = Maps_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n"
    ]);
    Maps_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function Maps_templateObject5() {
    var data = Maps_taggedTemplateLiteral([
        "\n  position: absolute;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 32px;\n  height: 80px;\n  right: -32px;\n"
    ]);
    Maps_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = Maps_taggedTemplateLiteral([
        "\n  transition-delay: 0.4s;\n  transition: 0.4s;\n  cursor: pointer;\n  transform: ",
        ";\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = Maps_taggedTemplateLiteral([
        "\n  width: 100%;\n  overflow-y: auto;\n  ",
        "\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = Maps_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  height: 100%;\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = Maps_taggedTemplateLiteral([
        "\n  display: flex;\n  width: 100%;\n  min-height: 60px;\n  box-sizing: border-box;\n  justify-content: center;\n  align-items: center;\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = Maps_taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  width: 100%;\n  gap: 12px 6px;\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
















var Maps = function(param) {
    var _type = param.type, type = _type === void 0 ? "entire" : _type, sidoList = param.sidoList, address = param.address, st = param.st;
    var ref = hooks_useMaps({
        sidoList: sidoList,
        address: address,
        st: st
    }), center = ref.center, handleChangeDebounceCenter = ref.handleChangeDebounceCenter, isShowReSearchButton = ref.isShowReSearchButton, markerListApiData = ref.markerListApiData, level = ref.level, mapRef = ref.mapRef, isLoading = ref.isLoading, hoverItem = ref.hoverItem, shopListNumber = ref.shopListNumber, sido = ref.sido, setSido = ref.setSido, pages = ref.pages, gungu = ref.gungu, setGungu = ref.setGungu, convertSidoDropdownOptionFormat = ref.convertSidoDropdownOptionFormat, convertGunGuDropdownOptionFormat = ref.convertGunGuDropdownOptionFormat, clusterListApiData = ref.clusterListApiData, groupCode = ref.groupCode, itemTypes = ref.itemTypes, handleClickItemTypes = ref.handleClickItemTypes, handleClickItemTypesReset = ref.handleClickItemTypesReset, handleChangegroupCode = ref.handleChangegroupCode, setHoverItem = ref.setHoverItem, setLevel = ref.setLevel, handleClickReSearchButton = ref.handleClickReSearchButton, handleChangeSido = ref.handleChangeSido, handleChangeGunGu = ref.handleChangeGunGu, handleClickCurrentLoactionButton = ref.handleClickCurrentLoactionButton, handleClickCluster = ref.handleClickCluster, handleChangePages = ref.handleChangePages, openState = ref.openState, handleClickMapSearchButton = ref.handleClickMapSearchButton, handleToggleMenu = ref.handleToggleMenu;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Maps_Container, Maps_objectSpreadProps(Maps_objectSpread({
        height: type === "remodeling" ? "calc(100vh - ".concat(styles/* GNB_HEIGHT */.I$, "px - ").concat(styles/* HEADER_HEIGHT */.Mz, "px)") : "calc(100vh - ".concat(styles/* HEADER_HEIGHT */.Mz, "px)")
    }, tracking/* default.tagGTM */.Z.tagGTM("shop_search")), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(MenuContainer, {
                width: openState ? "454px" : "0px",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(MenuBox, {
                        display: openState ? "flex" : "none",
                        backgroundColor: "color_chip.white",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(design_system_pc/* VStack */.gC, {
                                alignment: "start",
                                space: 20,
                                width: "100%",
                                pt: "32px",
                                pb: "20px",
                                pr: "28px",
                                pl: "28px",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* Text */.xv, {
                                        variant: "subTitle2",
                                        children: "매장찾기"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(design_system_pc/* HStack */.zn, {
                                        space: 8,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* Dropdown */.Lt, {
                                                variant: "list",
                                                size: "md",
                                                width: "100%",
                                                minWidth: "140.55px",
                                                placeholder: "시, 도",
                                                handleChange: handleChangeSido,
                                                selectValue: sido === null || sido === void 0 ? void 0 : sido.code,
                                                option: {
                                                    data: convertSidoDropdownOptionFormat === null || convertSidoDropdownOptionFormat === void 0 ? void 0 : convertSidoDropdownOptionFormat.map(function(sido) {
                                                        return Maps_objectSpread({}, sido, tracking/* default.tagGTM */.Z.tagGTM("shop_search_sido_dropdown_button", {
                                                            "option-value": sido === null || sido === void 0 ? void 0 : sido.value
                                                        }));
                                                    }),
                                                    styledProps: {
                                                        width: "195px",
                                                        height: "168px"
                                                    }
                                                }
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* Dropdown */.Lt, {
                                                variant: "list",
                                                size: "md",
                                                width: "100%",
                                                minWidth: "140.55px",
                                                placeholder: "군,구",
                                                // sido.code 36인 세종특별자치시만 군,구가 없음
                                                disabled: !sido || (sido === null || sido === void 0 ? void 0 : sido.code) === "36",
                                                handleChange: handleChangeGunGu,
                                                selectValue: gungu === null || gungu === void 0 ? void 0 : gungu.code,
                                                option: {
                                                    data: convertGunGuDropdownOptionFormat === null || convertGunGuDropdownOptionFormat === void 0 ? void 0 : convertGunGuDropdownOptionFormat.map(function(gungu) {
                                                        return Maps_objectSpread({}, gungu, tracking/* default.tagGTM */.Z.tagGTM("shop_search_gungu_dropdown_button", {
                                                            "option-value": gungu === null || gungu === void 0 ? void 0 : gungu.value
                                                        }));
                                                    }),
                                                    styledProps: {
                                                        width: "195px",
                                                        height: "168px"
                                                    }
                                                }
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* NewBasicButton */.vZ, {
                                                emphasis: "low",
                                                size: "md",
                                                icon: {
                                                    variant: "ic_search",
                                                    align: "left"
                                                },
                                                colorVariant: "blue",
                                                onClick: handleClickMapSearchButton,
                                                disabled: !sido,
                                                children: "지도검색"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterContainer, {
                                        children: type === "remodeling" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ShopSearch_CategoryChips, {
                                            currentValue: groupCode,
                                            type: "multi",
                                            gap: "12px 6px",
                                            list: constants/* SHOP_REMODELING_FILTER */.EEt,
                                            handleReset: handleClickItemTypesReset,
                                            onChange: handleChangegroupCode
                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ShopSearch_CategoryChips, {
                                            currentValue: itemTypes,
                                            type: "multi",
                                            gap: "12px 6px",
                                            list: constants/* SHOP_COMBINE_FILTER */.qKg,
                                            useCheckIcon: true,
                                            hasRefresh: true,
                                            handleReset: handleClickItemTypesReset,
                                            onChange: handleClickItemTypes
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ContentsBox, {
                                height: type === "remodeling" ? "calc(100vh - ".concat(styles/* GNB_HEIGHT */.I$, "px - ").concat(styles/* HEADER_HEIGHT */.Mz, "px - 240px)") : "calc(100vh - ".concat(styles/* HEADER_HEIGHT */.Mz, "px - 288px)"),
                                type: type,
                                children: [
                                    !isLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ResultList, {
                                        height: type === "entire" ? "calc(100% - ".concat(94 + styles/* PAGINATION_HEIGHT */.mM, "px)") : "calc(100% - 94px)",
                                        children: shopListNumber.totalElements ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(design_system_pc/* HStack */.zn, {
                                                    space: 2,
                                                    ml: "28px",
                                                    pt: "20px",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* Text */.xv, {
                                                            variant: "body1",
                                                            children: "전체"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* Box */.xu, {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* Text */.xv, {
                                                                variant: "headline6",
                                                                children: shopListNumber.totalElements || 0
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* Text */.xv, {
                                                            variant: "body1",
                                                            children: "개"
                                                        })
                                                    ]
                                                }),
                                                markerListApiData.map(function(item, index) {
                                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(kakaoMap_Card, Maps_objectSpread({
                                                        type: type,
                                                        item: item,
                                                        hoverItem: hoverItem,
                                                        setHoverItem: setHoverItem,
                                                        isFirstItem: index === 0
                                                    }, tracking/* default.tagGTM */.Z.tagGTM("shop_search_shop_detail_card_button", {
                                                        "shop-id": item.id
                                                    })), item.id);
                                                })
                                            ]
                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorMessageBox, {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorMessage/* default */.Z, {
                                                title: "이 지역 내에 검색 결과가 없습니다.",
                                                subTitle: "지도의 위치를 변경하시거나,\n일부 필터를 변경하여 다시 검색해주세요."
                                            })
                                        })
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingBox, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                            src: (0,utils/* getAsset */.Nh)("/assets/icons/loading-obj-new.gif"),
                                            height: "40px",
                                            width: "40px",
                                            alt: "loadingIcon"
                                        })
                                    }),
                                    shopListNumber.totalElements ? /*#__PURE__*/ (0,jsx_runtime.jsx)(PaginationBox, {
                                        borderTop: "1px solid",
                                        borderColor: "color_chip.gray.50",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BoardPagination/* default */.Z, {
                                            gtmName: "shop_search",
                                            page: pages,
                                            handlePage: handleChangePages,
                                            totalPages: Number(shopListNumber.totalPages) || 1
                                        })
                                    }) : null
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(OnOpenArrow, Maps_objectSpreadProps(Maps_objectSpread({
                        backgroundColor: "color_chip.white",
                        boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.25)",
                        onClick: handleToggleMenu
                    }, tracking/* default.tagGTM */.Z.tagGTM("shop_search_".concat(openState ? "close" : "open", "_menubox_button"))), {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Maps_IconBox, {
                            state: openState,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* Icongraphy */.Jb, {
                                variant: "ic_arrow_left_bold"
                            })
                        })
                    }))
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(kakaoMap_KakaoMap, {
                center: center,
                clusterListApiData: clusterListApiData,
                handleChangeCenter: handleChangeDebounceCenter,
                isShowReSearchButton: isShowReSearchButton,
                handleClickReSearchButton: function() {
                    handleClickReSearchButton();
                    setSido(undefined);
                    setGungu(undefined);
                },
                level: level,
                markerListApiData: markerListApiData,
                setLevel: setLevel,
                hoverItem: hoverItem,
                handleClickCluster: handleClickCluster,
                handleClickCurrentLoactionButton: handleClickCurrentLoactionButton,
                setHoverItem: setHoverItem,
                ref: mapRef
            })
        ]
    }));
};
/* harmony default export */ var Maps_Maps = (Maps);
var Maps_Container = (0,styled_components_browser_esm/* default */.ZP)(design_system_pc/* Box */.xu).withConfig({
    displayName: "Maps__Container",
    componentId: "sc-d8d3662e-0"
})(Maps_templateObject());
var MenuContainer = (0,styled_components_browser_esm/* default */.ZP)(design_system_pc/* Box */.xu).withConfig({
    displayName: "Maps__MenuContainer",
    componentId: "sc-d8d3662e-1"
})(Maps_templateObject1());
var ErrorMessageBox = (0,styled_components_browser_esm/* default */.ZP)(design_system_pc/* Box */.xu).withConfig({
    displayName: "Maps__ErrorMessageBox",
    componentId: "sc-d8d3662e-2"
})(Maps_templateObject2());
var MenuBox = (0,styled_components_browser_esm/* default */.ZP)(design_system_pc/* Box */.xu).withConfig({
    displayName: "Maps__MenuBox",
    componentId: "sc-d8d3662e-3"
})(Maps_templateObject3());
var ContentsBox = (0,styled_components_browser_esm/* default */.ZP)(design_system_pc/* Box */.xu).withConfig({
    displayName: "Maps__ContentsBox",
    componentId: "sc-d8d3662e-4"
})(Maps_templateObject4());
var OnOpenArrow = (0,styled_components_browser_esm/* default */.ZP)(design_system_pc/* Box */.xu).withConfig({
    displayName: "Maps__OnOpenArrow",
    componentId: "sc-d8d3662e-5"
})(Maps_templateObject5());
var Maps_IconBox = (0,styled_components_browser_esm/* default */.ZP)(design_system_pc/* Box */.xu).withConfig({
    displayName: "Maps__IconBox",
    componentId: "sc-d8d3662e-6"
})(_templateObject6(), function(param) {
    var state = param.state;
    return state ? "rotate3d(0)" : "rotate3d(0, 1, 0, 180deg)";
});
var ResultList = (0,styled_components_browser_esm/* default */.ZP)(design_system_pc/* Box */.xu).withConfig({
    displayName: "Maps__ResultList",
    componentId: "sc-d8d3662e-7"
})(_templateObject7(), common/* CustomScroll */.c);
var LoadingBox = (0,styled_components_browser_esm/* default */.ZP)(design_system_pc/* Box */.xu).withConfig({
    displayName: "Maps__LoadingBox",
    componentId: "sc-d8d3662e-8"
})(_templateObject8());
var PaginationBox = (0,styled_components_browser_esm/* default */.ZP)(design_system_pc/* Box */.xu).withConfig({
    displayName: "Maps__PaginationBox",
    componentId: "sc-d8d3662e-9"
})(_templateObject9());
var FilterContainer = (0,styled_components_browser_esm/* default */.ZP)(design_system_pc/* Box */.xu).withConfig({
    displayName: "Maps__FilterContainer",
    componentId: "sc-d8d3662e-10"
})(_templateObject10());

;// CONCATENATED MODULE: ./src/feat-components/ShopSearch/Maps/index.ts


;// CONCATENATED MODULE: ./src/feat-components/ShopSearch/ShopSearch.tsx



var ShopSearch = function(param) {
    var type = param.type, address = param.address, siDoList = param.siDoList, st = param.st;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Maps_Maps, {
        type: type,
        sidoList: siDoList,
        address: address,
        st: st
    });
};
/* harmony default export */ var ShopSearch_ShopSearch = (ShopSearch);

;// CONCATENATED MODULE: ./src/feat-components/ShopSearch/index.tsx


;// CONCATENATED MODULE: ./pages/shop/search.tsx
function search_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function search_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            search_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function search_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function search_objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        search_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}




var ShopPage = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(AppLayout/* default */.Z, {
        layoutType: "full",
        isFooterExist: false,
        quickSize: "full",
        isGnbExist: false,
        content: /*#__PURE__*/ (0,jsx_runtime.jsx)(ShopSearch_ShopSearch, search_objectSpreadProps(search_objectSpread({}, props), {
            type: "entire"
        }))
    });
};
var __N_SSP = true;
/* harmony default export */ var search = (ShopPage);


/***/ }),

/***/ 53644:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "d": function() { return /* binding */ searchAddressIpGateway; }
/* harmony export */ });
/* harmony import */ var _app_yarn_virtual_next_virtual_769137b2ab_0_cache_next_npm_12_2_3_07d597c2b7_b13b42fbb3_zip_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1861);
/* harmony import */ var _app_yarn_virtual_next_virtual_769137b2ab_0_cache_next_npm_12_2_3_07d597c2b7_b13b42fbb3_zip_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_app_yarn_virtual_next_virtual_769137b2ab_0_cache_next_npm_12_2_3_07d597c2b7_b13b42fbb3_zip_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(64630);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(axios__WEBPACK_IMPORTED_MODULE_1__);
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}


var searchAddressIpGateway = function() {
    return {
        getSearchIp: new ClientSearchIpGateway((axios__WEBPACK_IMPORTED_MODULE_1___default()))
    };
};
var ClientSearchIpGateway = /*#__PURE__*/ function() {
    "use strict";
    function ClientSearchIpGateway(httpClient) {
        _classCallCheck(this, ClientSearchIpGateway);
        this.httpClient = httpClient;
    }
    var _proto = ClientSearchIpGateway.prototype;
    _proto.exec = function exec() {
        return _asyncToGenerator(_app_yarn_virtual_next_virtual_769137b2ab_0_cache_next_npm_12_2_3_07d597c2b7_b13b42fbb3_zip_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            var apiResponse, result, data;
            return _app_yarn_virtual_next_virtual_769137b2ab_0_cache_next_npm_12_2_3_07d597c2b7_b13b42fbb3_zip_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return axios__WEBPACK_IMPORTED_MODULE_1___default()({
                            method: "get",
                            url: "https://geolocation-db.com/json/"
                        });
                    case 2:
                        apiResponse = _ctx.sent;
                        ;
                        if (apiResponse.status === 200) {
                            data = apiResponse.data;
                            result = {
                                code: 200,
                                data: {
                                    countryCode: data.country_code,
                                    countryName: data.country_name,
                                    city: data.city,
                                    postal: data.postal,
                                    latitude: data.latitude,
                                    longitude: data.longitude,
                                    ivIp: data.IPv4,
                                    state: data.state
                                },
                                message: ""
                            };
                        } else {
                            result = {
                                code: 500,
                                data: undefined,
                                message: "Error response Ip"
                            };
                        }
                        return _ctx.abrupt("return", result);
                    case 6:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }))();
    };
    return ClientSearchIpGateway;
}();


/***/ }),

/***/ 63401:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ shopGeoLocationGateway; }
/* harmony export */ });
/* harmony import */ var _app_yarn_virtual_next_virtual_769137b2ab_0_cache_next_npm_12_2_3_07d597c2b7_b13b42fbb3_zip_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1861);
/* harmony import */ var _app_yarn_virtual_next_virtual_769137b2ab_0_cache_next_npm_12_2_3_07d597c2b7_b13b42fbb3_zip_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_app_yarn_virtual_next_virtual_769137b2ab_0_cache_next_npm_12_2_3_07d597c2b7_b13b42fbb3_zip_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _di_container_axios__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(43856);
/* harmony import */ var _remodeling_shop__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(83651);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(35735);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_3__);
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}




var shopGeoLocationGateway = function() {
    return {
        postGeoLocation: new ClientPostGeoLocationGateway(_di_container_axios__WEBPACK_IMPORTED_MODULE_1__/* .axios */ .o)
    };
};
var ClientPostGeoLocationGateway = /*#__PURE__*/ function() {
    "use strict";
    function ClientPostGeoLocationGateway(httpClient) {
        _classCallCheck(this, ClientPostGeoLocationGateway);
        this.httpClient = httpClient;
    }
    var _proto = ClientPostGeoLocationGateway.prototype;
    _proto.exec = function exec(req) {
        return _asyncToGenerator(_app_yarn_virtual_next_virtual_769137b2ab_0_cache_next_npm_12_2_3_07d597c2b7_b13b42fbb3_zip_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            var mergeReg, apiResponse;
            return _app_yarn_virtual_next_virtual_769137b2ab_0_cache_next_npm_12_2_3_07d597c2b7_b13b42fbb3_zip_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        mergeReg = (0,lodash__WEBPACK_IMPORTED_MODULE_3__.merge)(req, {
                            deptCode: "MALL",
                            deviceCode: "WEB"
                        });
                        _ctx.next = 3;
                        return new _remodeling_shop__WEBPACK_IMPORTED_MODULE_2__/* .PostGeoLocationGateway */ .mk(_di_container_axios__WEBPACK_IMPORTED_MODULE_1__/* .axios */ .o).exec(mergeReg);
                    case 3:
                        apiResponse = _ctx.sent;
                        return _ctx.abrupt("return", apiResponse);
                    case 5:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }))();
    };
    return ClientPostGeoLocationGateway;
}();


/***/ }),

/***/ 59153:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "q": function() { return /* binding */ shopSearchGateway; }
/* harmony export */ });
/* harmony import */ var _di_container_axios__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(43856);
/* harmony import */ var _remodeling_shop__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(83651);


var shopSearchGateway = function() {
    return {
        getSidoData: new _remodeling_shop__WEBPACK_IMPORTED_MODULE_1__/* .GetShopSidoGateway */ .py(_di_container_axios__WEBPACK_IMPORTED_MODULE_0__/* .axios */ .o),
        getGunGuData: new _remodeling_shop__WEBPACK_IMPORTED_MODULE_1__/* .GetShopGunGusGateway */ .BV(_di_container_axios__WEBPACK_IMPORTED_MODULE_0__/* .axios */ .o),
        getShopListData: new _remodeling_shop__WEBPACK_IMPORTED_MODULE_1__/* .GetShopListGateway */ .mV(_di_container_axios__WEBPACK_IMPORTED_MODULE_0__/* .axios */ .o),
        getDisplayShopListData: new _remodeling_shop__WEBPACK_IMPORTED_MODULE_1__/* .GetDisplayShopListGateway */ .a7(_di_container_axios__WEBPACK_IMPORTED_MODULE_0__/* .axios */ .o),
        getShopClusterListData: new _remodeling_shop__WEBPACK_IMPORTED_MODULE_1__/* .GetShopClusterListGateway */ .Hh(_di_container_axios__WEBPACK_IMPORTED_MODULE_0__/* .axios */ .o)
    };
};


/***/ }),

/***/ 34251:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(91987);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(35735);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(71975);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}



var useWindowHistory = function() {
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    var handleReplaceState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function(data, unused, url) {
        if (true) {
            router.replace("".concat(url));
            if ("postMessage" in window) {
                window.postMessage(JSON.stringify({
                    as: "hs",
                    tp: "history",
                    ev: "replaceState",
                    dt: {
                        data: data,
                        unused: unused,
                        url: url
                    }
                }));
            }
        }
    }, [
        router
    ]);
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)([]), stack = ref[0], setStack = ref[1];
    var handleAddListener = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function(id, eventType, callback) {
        setStack(function(values) {
            var newValues = _toConsumableArray(values);
            newValues.push({
                id: id,
                eventType: eventType,
                callback: callback
            });
            return newValues;
        });
    }, []);
    var handleRemoveListener = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function(id, eventType) {
        setStack(function(values) {
            var newValues = _toConsumableArray(values);
            var found = -1;
            var runTm = 10;
            do {
                found = lodash__WEBPACK_IMPORTED_MODULE_1___default().findIndex(newValues, {
                    id: id,
                    eventType: eventType
                });
                newValues.splice(found, 1);
                runTm--;
            }while (found >= 0 && runTm >= 0);
            return newValues;
        });
    }, []);
    var handlePostMessage = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function(event) {
        try {
            var payload = JSON.parse(event.data);
            stack.forEach(function(item) {
                if (payload.as === "hs" && payload.tp === "history" && payload.ev === item.eventType) {
                    item.callback(payload.dt);
                }
            });
        } catch (error) {}
    }, [
        stack
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        window.addEventListener("message", handlePostMessage);
        return function() {
            window.removeEventListener("message", handlePostMessage);
        };
    }, [
        handlePostMessage
    ]);
    return {
        handleReplaceState: handleReplaceState,
        handleAddListener: handleAddListener,
        handleRemoveListener: handleRemoveListener
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (useWindowHistory);


/***/ }),

/***/ 44542:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ ErrorMessage_ErrorMessage; }
});

// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(61261);
// EXTERNAL MODULE: ./src/styles/index.ts
var styles = __webpack_require__(52655);
// EXTERNAL MODULE: ./src/ui/Image/index.ts
var Image = __webpack_require__(71267);
// EXTERNAL MODULE: ./src/utils/index.ts
var utils = __webpack_require__(67748);
// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/index.js
var react = __webpack_require__(91987);
// EXTERNAL MODULE: ../../.yarn/unplugged/styled-components-virtual-24edae5a63/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(10278);
;// CONCATENATED MODULE: ./src/ui/ErrorMessage/ErrorMessage.tsx
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  width: fit-content;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        ";\n  width: fit-content;\n  white-space: pre-wrap;\n  margin-top: ",
        "px;\n  text-align: center;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        ";\n  width: fit-content;\n  white-space: pre-wrap;\n  margin-top: 8px;\n  text-align: center;\n  color: ",
        ";\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}






var IC_EMPTY_56 = "/assets/icons/ic_empty_56.svg";
var IC_EMPTY_72 = "/assets/icons/ic_empty_72.svg";
var ErrorMessage = function(param) {
    var _size = param.size, size = _size === void 0 ? "m" : _size, title = param.title, subTitle = param.subTitle;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ErrorMessageWrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                src: size === "l" ? (0,utils/* getAsset */.Nh)(IC_EMPTY_72) : (0,utils/* getAsset */.Nh)(IC_EMPTY_56),
                width: size === "l" ? 72 : 56,
                height: size === "l" ? 72 : 56,
                alt: size === "l" ? (0,utils/* getAsset */.Nh)(IC_EMPTY_72) : (0,utils/* getAsset */.Nh)(IC_EMPTY_56)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TitleText, {
                size: size,
                children: title
            }),
            subTitle && /*#__PURE__*/ (0,jsx_runtime.jsx)(SubTitleText, {
                children: subTitle
            })
        ]
    });
};
/* harmony default export */ var ErrorMessage_ErrorMessage = (ErrorMessage);
var ErrorMessageWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "ErrorMessage__ErrorMessageWrapper",
    componentId: "sc-a2a57fb7-0"
})(_templateObject());
var TitleText = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    displayName: "ErrorMessage__TitleText",
    componentId: "sc-a2a57fb7-1"
})(_templateObject1(), styles/* theme.typography.body1 */.rS.typography.body1, function(param) {
    var size = param.size;
    return size === "l" ? 24 : 12;
});
var SubTitleText = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    displayName: "ErrorMessage__SubTitleText",
    componentId: "sc-a2a57fb7-2"
})(_templateObject2(), styles/* theme.typography.caption1 */.rS.typography.caption1, styles/* theme.colors.neutral_colors.gray.700 */.rS.colors.neutral_colors.gray[700]);

;// CONCATENATED MODULE: ./src/ui/ErrorMessage/index.ts



/***/ }),

/***/ 33488:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(61261);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(91987);


function MarkerIcon(props) {
    if (props.groupCode === "OH") {
        if (props.isHover) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
                width: "49",
                height: "49",
                viewBox: "0 0 49 49",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                        cx: "24.4492",
                        cy: "24.6845",
                        r: "19",
                        fill: "#0064FF"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M12.4492 22.4237C12.4492 21.9943 12.6681 21.5887 13.0429 21.3233L24.2509 14.4413C24.5329 14.2416 24.9301 14.2416 25.2122 14.4413L35.856 21.3233C36.2309 21.5887 36.4497 21.9943 36.4497 22.4237L36.4497 33.6776C36.4497 34.4508 35.7535 35.0776 34.8947 35.0776H14.0043C13.1454 35.0776 12.4492 34.4508 12.4492 33.6776L12.4492 22.4237Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M20.0706 27.6543C20.0706 28.2135 19.9606 28.6939 19.7408 29.0953C19.5209 29.4968 19.221 29.8015 18.841 30.0094C18.4611 30.2173 18.0345 30.3213 17.5613 30.3213C17.0834 30.3213 16.6544 30.2173 16.2744 30.0094C15.8945 29.7991 15.5946 29.4932 15.3747 29.0918C15.1549 28.6903 15.0449 28.2111 15.0449 27.6543C15.0449 27.0951 15.1549 26.6148 15.3747 26.2133C15.5946 25.8118 15.8945 25.5071 16.2744 25.2992C16.6544 25.0913 17.0834 24.9874 17.5613 24.9874C18.0345 24.9874 18.4611 25.0913 18.841 25.2992C19.221 25.5071 19.5209 25.8118 19.7408 26.2133C19.9606 26.6148 20.0706 27.0951 20.0706 27.6543ZM16.4501 27.6543C16.4501 28.1299 16.5457 28.4943 16.7369 28.7476C16.928 29.001 17.2029 29.1288 17.5613 29.1312C17.9174 29.1288 18.191 29.001 18.3822 28.7476C18.5734 28.4943 18.6678 28.1299 18.6654 27.6543C18.6678 27.1764 18.5734 26.8107 18.3822 26.5574C18.191 26.3041 17.9174 26.1775 17.5613 26.1775C17.2029 26.1775 16.928 26.3041 16.7369 26.5574C16.5457 26.8107 16.4501 27.1764 16.4501 27.6543Z",
                        fill: "#0064FF"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M20.5905 25.0591H22.7986C23.181 25.0591 23.5167 25.1355 23.8059 25.2885C24.0974 25.439 24.3221 25.6517 24.4798 25.9265C24.6399 26.2014 24.72 26.5192 24.72 26.88C24.72 27.2457 24.6387 27.5659 24.4762 27.8407C24.3137 28.1132 24.0843 28.3223 23.788 28.468C23.4916 28.6138 23.1475 28.6867 22.7556 28.6867H21.9526V30.2496H20.5905V25.0591ZM22.4832 27.6257C22.7389 27.6233 22.9384 27.5563 23.0818 27.4249C23.2252 27.2911 23.2957 27.1095 23.2933 26.88C23.2957 26.653 23.2252 26.475 23.0818 26.3459C22.9384 26.2169 22.7389 26.1512 22.4832 26.1488H21.9526V27.6257H22.4832Z",
                        fill: "#0064FF"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M25.1108 25.0591H28.8173V26.1631H26.473V27.1023H28.6238V28.2064H26.473V29.1455H28.8102V30.2496H25.1108V25.0591Z",
                        fill: "#0064FF"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M33.8539 30.2496H32.714L30.7854 27.4464H30.7496V30.2496H29.3874V25.0591H30.5489L32.4487 27.8479H32.4917V25.0591H33.8539V30.2496Z",
                        fill: "#0064FF"
                    })
                ]
            });
        }
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
            width: "49",
            height: "49",
            viewBox: "0 0 49 49",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                    cx: "24.2949",
                    cy: "24.6845",
                    r: "21.25",
                    fill: "white",
                    stroke: "#484848",
                    strokeWidth: "1.5"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    d: "M9.89453 21.9715C9.89453 21.4563 10.1571 20.9695 10.607 20.651L24.0565 12.3926C24.395 12.153 24.8716 12.153 25.2101 12.3926L37.9827 20.651C38.4325 20.9695 38.6951 21.4563 38.6951 21.9715L38.6951 35.4762C38.6951 36.4041 37.8597 37.1562 36.8291 37.1562H11.7606C10.73 37.1562 9.89455 36.4041 9.89455 35.4762L9.89453 21.9715Z",
                    fill: "#484848"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    d: "M19.0405 28.2483C19.0405 28.9193 18.9086 29.4957 18.6448 29.9775C18.381 30.4593 18.0211 30.8249 17.5651 31.0744C17.1091 31.3239 16.5973 31.4486 16.0295 31.4486C15.4559 31.4486 14.9412 31.3239 14.4852 31.0744C14.0292 30.822 13.6693 30.455 13.4055 29.9732C13.1417 29.4914 13.0098 28.9164 13.0098 28.2483C13.0098 27.5772 13.1417 27.0008 13.4055 26.519C13.6693 26.0373 14.0292 25.6716 14.4852 25.4221C14.9412 25.1727 15.4559 25.0479 16.0295 25.0479C16.5973 25.0479 17.1091 25.1727 17.5651 25.4221C18.0211 25.6716 18.381 26.0373 18.6448 26.519C18.9086 27.0008 19.0405 27.5772 19.0405 28.2483ZM14.696 28.2483C14.696 28.8189 14.8107 29.2563 15.0401 29.5602C15.2695 29.8642 15.5993 30.0176 16.0295 30.0205C16.4567 30.0176 16.7851 29.8642 17.0145 29.5602C17.2439 29.2563 17.3572 28.8189 17.3543 28.2483C17.3572 27.6747 17.2439 27.236 17.0145 26.932C16.7851 26.628 16.4567 26.476 16.0295 26.476C15.5993 26.476 15.2695 26.628 15.0401 26.932C14.8107 27.236 14.696 27.6747 14.696 28.2483Z",
                    fill: "white"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    d: "M19.6644 25.1339H22.3142C22.773 25.1339 23.1759 25.2257 23.5229 25.4092C23.8728 25.5899 24.1424 25.8451 24.3316 26.1749C24.5238 26.5047 24.6198 26.8861 24.6198 27.3191C24.6198 27.7579 24.5223 28.1422 24.3273 28.4719C24.1323 28.7989 23.857 29.0498 23.5014 29.2247C23.1458 29.3996 22.7329 29.4871 22.2626 29.4871H21.299V31.3626H19.6644V25.1339ZM21.9357 28.2139C22.2425 28.211 22.482 28.1307 22.654 27.973C22.8261 27.8124 22.9107 27.5944 22.9078 27.3191C22.9107 27.0467 22.8261 26.8331 22.654 26.6782C22.482 26.5233 22.2425 26.4445 21.9357 26.4416H21.299V28.2139H21.9357Z",
                    fill: "white"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    d: "M25.0889 25.1339H29.5367V26.4588H26.7235V27.5858H29.3044V28.9107H26.7235V30.0377H29.5281V31.3626H25.0889V25.1339Z",
                    fill: "white"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    d: "M35.5805 31.3626H34.2126L31.8984 27.9988H31.8554V31.3626H30.2208V25.1339H31.6145L33.8943 28.4806H33.9459V25.1339H35.5805V31.3626Z",
                    fill: "white"
                })
            ]
        });
    }
    if (props.isHover) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
            width: "49",
            height: "49",
            viewBox: "0 0 49 49",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                    cx: "24.4492",
                    cy: "24.4",
                    r: "19",
                    fill: "#0064FF"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M22.9273 15.4038C23.1654 15.7083 23.1115 16.1483 22.8069 16.3864L15.9078 21.7799V30.3982L21.8234 30.3978L21.8236 31.7978L15.2079 31.7983C15.0222 31.7983 14.8441 31.7246 14.7129 31.5933C14.5816 31.462 14.5078 31.284 14.5078 31.0983V21.4386C14.5078 21.2232 14.607 21.0198 14.7767 20.8871L21.9447 15.2834C22.2492 15.0453 22.6892 15.0992 22.9273 15.4038Z",
                    fill: "white"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M23.2869 15.1267C22.3649 14.7431 21.3492 15.4206 21.3492 16.4193V31.7983L27.6137 31.7983V24.0809L32.4303 25.2026V31.7983L34.883 31.7983C35.6562 31.7983 36.283 31.1715 36.283 30.3983V21.4667C36.283 20.9013 35.9428 20.3913 35.4207 20.1741L23.2869 15.1267Z",
                    fill: "white"
                })
            ]
        });
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: "49",
        height: "49",
        viewBox: "0 0 49 49",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M46.4492 24.4C46.4492 36.5503 36.5995 46.4 24.4492 46.4C12.299 46.4 2.44922 36.5503 2.44922 24.4C2.44922 12.2498 12.299 2.40002 24.4492 2.40002C36.5995 2.40002 46.4492 12.2498 46.4492 24.4Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M24.4492 45.4C36.0472 45.4 45.4492 35.998 45.4492 24.4C45.4492 12.802 36.0472 3.40002 24.4492 3.40002C12.8512 3.40002 3.44922 12.802 3.44922 24.4C3.44922 35.998 12.8512 45.4 24.4492 45.4ZM24.4492 46.4C36.5995 46.4 46.4492 36.5503 46.4492 24.4C46.4492 12.2498 36.5995 2.40002 24.4492 2.40002C12.299 2.40002 2.44922 12.2498 2.44922 24.4C2.44922 36.5503 12.299 46.4 24.4492 46.4Z",
                fill: "#E2E2E2"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                cx: "24.4492",
                cy: "24.4",
                r: "19",
                fill: "#555555"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M22.9273 15.4038C23.1654 15.7083 23.1115 16.1483 22.8069 16.3864L15.9078 21.7799V30.3982L21.8234 30.3978L21.8236 31.7978L15.2079 31.7983C15.0222 31.7983 14.8441 31.7246 14.7129 31.5933C14.5816 31.462 14.5078 31.284 14.5078 31.0983V21.4386C14.5078 21.2232 14.607 21.0198 14.7767 20.8871L21.9447 15.2834C22.2492 15.0453 22.6892 15.0992 22.9273 15.4038Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M23.2869 15.1267C22.3649 14.7431 21.3492 15.4206 21.3492 16.4193V31.7983L27.6137 31.7983V24.0809L32.4303 25.2026V31.7983L34.883 31.7983C35.6562 31.7983 36.283 31.1715 36.283 30.3983V21.4667C36.283 20.9013 35.9428 20.3913 35.4207 20.1741L23.2869 15.1267Z",
                fill: "white"
            })
        ]
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (MarkerIcon);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9344,8974,3851,378,2413,3651,5262,9774,2888,179], function() { return __webpack_exec__(33818); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);